import { Component, Input } from "@angular/core"
import { environment } from "src/environments/environment"
declare var $: any

@Component({
	selector: "app-civic-price-list",
	templateUrl: "./civic-price-list.component.html",
	styleUrls: ["./civic-price-list.component.scss"]
})
export class CivicPriceListComponent {
	public assets_version = environment.ASSETS_VERSION
	public pathImgsMarkers = environment.path_imgs_markers
	@Input() buildingType: any

	open(content) {
		$("#" + content).modal("show")
	}
}
